

































import AbpBase from "../../../lib/abpbase";
import { Component } from "vue-property-decorator";
import { QueryModuleList, QueryModuleColumnList } from "../../../api/systemBasic";
import addOrEdit from "./addOrEdit.vue";

/**
 * 模块字段配置模块
 */
@Component({
  components: { addOrEdit }
})
export default class extends AbpBase {
  queryString: "";
  moduleList = [];
  columnList = [];
  loading = false;
  addOrEditShow = false;
  addOrEditData: any = {};
  currentModule: any = {};
  columns = [
    {
      title: "字段编码",
      key: "columnCode",
      width: 200,
    },
    {
      title: "字段名称",
      key: "columnName",
    },
    {
      title: "校验规则",
      key: "columnRegex",
    },
    {
      title: "校验提示",
      key: "columnRegexNote",
    },
    {
      title: "是否必填",
      key: "columnRequired",
    },
    {
      title: "是否显示",
      key: "isShow",
      width: 110,
      render: (h1: any, p: any) => {
        let h = this.$createElement;
        return h("span", p.row.isShow ? "√" : "");
      },
    },
    {
      title: "显示顺序",
      key: "sort",
      width: 110,
    },
    {
      title: "操作",
      width: 80,
      render: (h1: any, p: any) => {
        const h = this.$createElement;
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "10px",
              },
              on: {
                click: () => {
                  this.edit(p.row);
                },
              },
            },
            "编辑"
          ),
        ]);
      },
    },
  ];

  created() {
    this.getModules();
  }

  async getModules() {
    this.currentModule = {};
    this.loading = true;
    let res = await QueryModuleList({ queryString: this.queryString });
    this.moduleList = res.objects;
    this.loading = false;
    // 默认选中第一项
    if (this.moduleList && this.moduleList.length > 0) {
      this.currentModule = this.moduleList[0];
      this.getColumns(this.currentModule.moduleName);
    }
  }

  async getColumns(moduleName: string) {
    this.loading = true;
    let res = await QueryModuleColumnList({ moduleName: moduleName });
    this.columnList = res.objects;
    this.loading = false;
  }

  edit(row: any) {
    this.addOrEditData = row;
    this.addOrEditShow = true;
  }

  handleModuleClick(module) {
    this.currentModule = module;
    this.getColumns(module.moduleName);
  }

  async handleModuleColumnSave() {
    this.getColumns(this.currentModule.moduleName);
    // 重新加载store中的数据
    await this.$store.dispatch({
      type: "columnSettings/init",
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/moduleColumnSetting/index.vue